import tab01Retina from 'marketing-website/media/images/pages/homepage/01-designing@2x.jpg';
import tab02Retina from 'marketing-website/media/images/pages/homepage/02-prototyping@2x.jpg';
import tab03Retina from 'marketing-website/media/images/pages/homepage/03-handoff@2x.jpg';
import tab04Retina from 'marketing-website/media/images/pages/homepage/04-collaboration@2x.jpg';
import tab05Retina from 'marketing-website/media/images/pages/homepage/06-usertesting@2x.jpg';
import tab01Mobile from 'marketing-website/media/images/pages/homepage/01-designing-small.jpg';
import tab02Mobile from 'marketing-website/media/images/pages/homepage/02-prototyping-small.jpg';
import tab03Mobile from 'marketing-website/media/images/pages/homepage/03-handoff-small.jpg';
import tab04Mobile from 'marketing-website/media/images/pages/homepage/04-collaboration-small.jpg';
import tab05Mobile from 'marketing-website/media/images/pages/homepage/06-usertesting-small.jpg';

const homePageTabs = [
  {
    id: 0,
    title: 'Design and Wireframe',
    subtitle: 'Create beautiful interfaces and wireframes in minutes',
    src: tab01Retina,
    srcMobile: tab01Mobile,
    maxWidth: 950,
  },
  {
    id: 1,
    title: 'Prototype',
    subtitle: 'Make designs interactive. No code required',
    src: tab02Retina,
    srcMobile: tab02Mobile,
    maxWidth: 950,
  },
  {
    id: 2,
    title: 'Handoff',
    subtitle: 'Design to development, automated',
    src: tab03Retina,
    srcMobile: tab03Mobile,
    maxWidth: 950,
  },

  {
    id: 3,
    title: 'User Testing',
    subtitle: 'See how users interact with your designs and prototypes',
    src: tab05Retina,
    srcMobile: tab05Mobile,
    maxWidth: 950,
  },
  {
    id: 4,
    title: 'Collaboration',
    subtitle: 'Centralise feedback and ideas',
    src: tab04Retina,
    srcMobile: tab04Mobile,
    maxWidth: 950,
  },
];

export default homePageTabs;



// WEBPACK FOOTER //
// ./src/configs/pages/homepage/tabs.js